import {ItecColFilters, ItecDataGrid, ItecGridColsDef as GridColsDef, useItecDataGrid} from 'src/lib/itaptec/datagrid/src'
import {GroupDTOFields, GroupFilterDTOFields, GroupViewDTO, GroupViewDTOFields} from 'src/types/group/groupData'
import {HttpGroup} from 'src/http/group/httpGroup'
import {EntityWithIdFields} from 'src/lib/itaptec/http_client/src'
import {Card, CardHeader, Chip, Dialog, IconButton, Tooltip} from '@mui/material'
import CachedIcon from '@mui/icons-material/Cached'
import {useConfirmationDialog} from 'src/hooks/useConfirmationDialog'
import toast from 'react-hot-toast'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import EditIcon from '@mui/icons-material/Edit'
import {GridActionsCellItem} from '@mui/x-data-grid'
import {ReactElement, useState} from 'react'
import EditSectorComercialesGrupo from './components/EditSectorComercialesGrupo'
import GroupFormDialog from './components/GroupFormDialog'
import {HttpSystems} from 'src/http/workflow/httpSystems'
import {z} from 'zod'
import {EntityWithIdAndDescriptionFields, PaisLogoFields, schemaSelectionOption} from 'src/types'
import DomainIcon from '@mui/icons-material/Domain'
import {WrapperTable} from '../components'
import {CountryAvatar} from "../../../../../components/icons/CountryAvatar";
import {UserViewDTOFields} from "../../../../../types/user/userData";
import { usePaisLogo } from 'src/hooks/usePaisLogo'
import { HttpCacheWorkflow } from 'src/http/workflow/httpCacheWorkflow'

const opcionActivo = {value: 1, label: "Activos", color: "success"}
const opcionInactivo = {value: 2, label: "Inactivos", color: "error"}

const toggleActivoOptions: any[] = [
  opcionActivo,
  opcionInactivo,
]

const schemaFiltroGrupos = z.object({
  // [GroupFilterDTOFields.ActiveOnly]: z.boolean(),

  [GroupFilterDTOFields.ActiveOnly]: z.array(schemaSelectionOption).optional(),
  [GroupFilterDTOFields.Name]: z.string().optional(),
  [GroupFilterDTOFields.CodsPais]: z.array(schemaSelectionOption).optional(),
  [GroupFilterDTOFields.CodsTipoMensaje]: z.array(schemaSelectionOption).optional()
})

type SchemaFiltroGruposTipo = z.infer<typeof schemaFiltroGrupos>

function TableGroups() {
  const {askConfirmation} = useConfirmationDialog()
  const {getPaisLogoPorCodigo, paisLogos, loading} = usePaisLogo()
  

  const columnas: GridColsDef<GroupViewDTO>[] = [
    // {
    //     headerName: 'Id',
    //     field: EntityWithIdFields.Id
    // },
    {
      headerName: 'Grupo',
      field: GroupDTOFields.Name,
      flex: 3
    },
    {
      headerName: 'Perfil',
      field: GroupViewDTOFields.ProfileName,
      flex: 2
    },
    {
      headerName: 'Pais',
      field: 'pais',
      flex: 2,
      renderCell: ({row: group}) => (
        <Chip
          label={group[GroupViewDTOFields.CountryName]}
          size='small'
          variant='outlined'
          avatar={
            <CountryAvatar countryCode={group[GroupViewDTOFields.CodPais]}/>
          }
        />
      )
    },
    {
      headerName: 'Sistema',
      field: GroupViewDTOFields.NombreSistema,
      flex: 3
    },
    {
      headerName: 'Observaciones',
      field: GroupDTOFields.Observations,
      flex: 2
    },
    {
      headerName: 'Activo',
      field: GroupViewDTOFields.Active,
      type: 'boolean',
      flex: 1,
    },
    {
      field: 'actions',
      type: 'actions',
      getActions: ({row}) => getActions(row, true)
    }
  ]

  const filtros: ItecColFilters<SchemaFiltroGruposTipo> = {
    [GroupDTOFields.Name]: {
      type: "text",
      name: GroupFilterDTOFields.Name,
      props: {
        debounceTime: 500,
        size: "small",
        label: "Grupo",
        autoFocus: true,
      },
    },
    pais: {
      type: 'multiselect',
      name: GroupFilterDTOFields.CodsPais,
      props: {
        getOptions: () =>
          Promise.resolve(paisLogos).then(res =>
            res.map(s => ({
              value: s.id,
              label: s[EntityWithIdAndDescriptionFields.Description],
              icon: <CountryAvatar countryCode={s[PaisLogoFields.CodPais]}/>
            }))
            ),
        TagComponent: ({value, ...rest}) => (
          <Chip
            label={value.label}
            icon={value.icon as ReactElement}
            variant='filled'
            size='small'
            {...rest}
          />
        ),
        size: 'small'
      }
    },
    [GroupViewDTOFields.NombreSistema]: {
      type: 'multiselect',
      name: GroupFilterDTOFields.CodsTipoMensaje,
      props: {
        getOptions: () =>
          HttpCacheWorkflow.getSistemasTipos().then(res =>
            res.map(s => ({
              value: s.id,
              label: s.descripcion
            }))
          ),
        size: 'small'
      }
    },
    [GroupViewDTOFields.Active]: {
      type: "multiple-button-group",
      name: GroupFilterDTOFields.ActiveOnly,
      props: {
        options: toggleActivoOptions,
        enforceValueSet: false,
        size: "small",
        toggleButtonProps: (option: any) => ({
          color: option.color,
        }),
      },
    },
  }

  const getActions = (group: GroupViewDTO, small: boolean) => [
    group[GroupViewDTOFields.Active] ? (
      <GridActionsCellItem
        onClick={() =>
          askConfirmation(() => {
            const promise = HttpGroup.deactivateGroup(group.id)

            toast
              .promise(promise, {
                success: 'Inactivado',
                error: 'No se pudo inactivar',
                loading: 'Inactivando'
              })
              .then(() => refetch())
          })
        }
        icon={
          <Tooltip title='Inactivar'>
            <PersonRemoveIcon color='error'/>
          </Tooltip>
        }
        label='Inactivar'
        showInMenu={small}
      />
    ) : (
      <GridActionsCellItem
        onClick={() =>
          askConfirmation(() => {
            const promise = HttpGroup.activateGroup(group.id)

            toast
              .promise(promise, {
                success: 'Activado',
                error: 'No se pudo activar',
                loading: 'Activando'
              })
              .then(() => refetch())
          })
        }
        icon={
          <Tooltip title='Activar'>
            <PersonAddIcon color='success'/>
          </Tooltip>
        }
        label='Activar'
        showInMenu={small}
      />
    ),
    <GridActionsCellItem
      icon={
        <Tooltip title='Editar'>
          <EditIcon color='info'/>
        </Tooltip>
      }
      label='Editar'
      showInMenu={small}
      onClick={() => {
        setSelectedGroup(group)
        setShowFormDialog(true)
      }}
    />,
    <GridActionsCellItem
      icon={
        <Tooltip title='Sectores comerciales'>
          <DomainIcon color='info'/>
        </Tooltip>
      }
      label='Sectores comerciales'
      showInMenu={small}
      onClick={() => {
        setGrupoSectores(group[EntityWithIdFields.Id])
      }}
    />
  ]

  const opcionUsuarioActivo = (filter: SchemaFiltroGruposTipo, field: keyof SchemaFiltroGruposTipo) => {
    const fieldValue = filter?.[field];

    if (Array.isArray(fieldValue)) {
      console.log('fieldvalue', fieldValue)
      if (fieldValue.some(option => option.value === opcionActivo.value && option.label === opcionActivo.label) &&
        fieldValue.some(option => option.value === opcionInactivo.value && option.label === opcionInactivo.label)) {
        return undefined;
      } else if (fieldValue.some(option => option.value === opcionActivo.value && option.label === opcionActivo.label)) {
        return true;
      } else if (fieldValue.some(option => option.value === opcionInactivo.value && option.label === opcionInactivo.label)) {
        return false;
      }
    }
  }

  const {
    datagridProps,
    control: {
      query: {refetch}
    }
  } = useItecDataGrid({
    pagination: true,
    columns: columnas,
    getEntitiesPaginated: (pagination, filter) =>
      HttpGroup.getGroupList(
        pagination,
        filter
          ? {
            nombre: filter[GroupFilterDTOFields.Name],
            codsPais: filter[GroupFilterDTOFields.CodsPais]?.map(c => c.value),
            codsTipoMensaje: filter[GroupFilterDTOFields.CodsTipoMensaje]?.map(c => c.value),
            [GroupFilterDTOFields.ActiveOnly]: opcionUsuarioActivo(filter, GroupFilterDTOFields.ActiveOnly),
          }
          : {}
      ),
    density: 'compact',
    filters: filtros
  })

  const [showFormDialog, setShowFormDialog] = useState<boolean>(false)
  const [selectedGroup, setSelectedGroup] = useState<GroupViewDTO>()
  const [grupoSectores, setGrupoSectores] = useState<number>()

  return (
    <WrapperTable>
      <Card>
        <CardHeader
          title='Administración de grupos'
          action={
            <IconButton disabled={datagridProps.loading} onClick={() => refetch()}>
              <CachedIcon/>
            </IconButton>
          }
        />
        <ItecDataGrid {...datagridProps} />
      </Card>
      <>
        <GroupFormDialog
          open={showFormDialog}
          onClose={() => setShowFormDialog(false)}
          group={selectedGroup}
          maxWidth={'md'}
          onAfterSubmit={() => {
            refetch()
            setSelectedGroup(undefined)
            setShowFormDialog(false)
          }}
          onSubmitError={(e: string) => console.log(e)}
        />
        <Dialog open={!!grupoSectores} fullWidth maxWidth='lg' keepMounted={false} sx={{maxHeight: '100%'}}>
          {grupoSectores && (
            <EditSectorComercialesGrupo
              onClose={() => {
                setGrupoSectores(undefined)
              }}
              grupo={grupoSectores}
            />
          )}
        </Dialog>
      </>
    </WrapperTable>
  )
}

export default TableGroups
